import request from "@/utils/request";

export default function swapOrder(id,isUp) {
    return request({
        url: `/storeProduct/agency/swap/`+id+`/`+isUp,
        method: 'get',
    })
}
